<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="Me">
    <div class="Me__modal">
      <div class="Me__modal__close" @click="displayMe(false)">
        <Exit></Exit>
      </div>
      <div class="Me__modal__title">{{ $t('ACCOUNT') }}</div>
      <div class="Me__modal__avatar">
        <div class="Me__modal__avatar__ball" :style="{ backgroundImage: `url(${me.avatar})` }">
          <template v-if="!me.avatar">
            {{ me.first ? me.first[0] : '?' }}{{ me.last ? me.last[0] : '?' }}
          </template>
          <div class="Me__modal__avatar__ball__capture" @click="newAvatar()">
            <Camera />
          </div>
        </div>
      </div>
      <div class="Me__modal__infoGroup">
        <div class="Me__modal__infoGroup__data">{{ me.first ? me.first : '&nbsp;' }}</div>
        <div class="Me__modal__infoGroup__label">{{ $t('ME_FIRSTNAME') }}</div>
      </div>
      <div class="Me__modal__infoGroup">
        <div class="Me__modal__infoGroup__data">{{ me.last ? me.last : '&nbsp;' }}</div>
        <div class="Me__modal__infoGroup__label">{{ $t('ME_LASTNAME') }}</div>
      </div>
      <div class="Me__modal__infoGroup last">
        <div class="Me__modal__infoGroup__data">{{ me.nick ? me.nick : '&nbsp;' }}</div>
        <div class="Me__modal__infoGroup__label">{{ $t('ME_NICKNAME') }}</div>
      </div>
      <!--
      <div class="Me__modal__infoGroup last">
        <div class="Me__modal__infoGroup__data">{{ me.email ? me.email : '&nbsp;' }}</div>
        <div class="Me__modal__infoGroup__label">{{ $t('ME_EMAIL') }}</div>
      </div>
      -->
      <div class="Me__modal__button" @click="exit()">
        {{ $t('ME_LOGOUT') }}
      </div>
    </div>
  </section>
</template>

<script lang="js">
import { mapState, mapMutations, mapActions } from 'vuex';
import Exit from '@/components/glyphs/Exit.vue';
import Camera from './glyphs/SimpleCamera.vue';

export default {
  name: 'me',
  components: {
    Exit,
    Camera,
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapMutations(['displayMe']),
    ...mapActions(['logout']),
    newAvatar() {
      if (typeof window.front_end_change_avatar === 'function') {
        window.front_end_change_avatar();
      }
    },
    exit() {
      this.logout()
        .then(() => {
          this.$ls.remove('storageAccessData');
          this.$ls.remove('availablePlans');
          this.$ls.remove('storageHomeData');
          this.$cookies.remove(`${window.TOK_NS}storageAccessData`);
          const url = `https://acceptance.tok.tv:8443/webidentityprovider/logout?app=toktvsdk&service=tokvp&url=${this.baseUrl}`;
          window.location.href = url;
        });
    },
  },
  computed: {
    ...mapState([
      'namespace',
      'me',
      'baseUrl',
    ]),
  },
};
</script>
